/**
 * The State
 *
 * @type { Object }
 */
export default {
	decks: crb_booking_app.data
}


// WEBPACK FOOTER //
// ./src/store/decks/state.js